// src/components/sections/PricingSection.jsx
// Pricing tiers section

import React from 'react';
import { PRICING_PLANS } from '../../config/constants';
import Button from '../common/Button';

const PricingSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="pricing" className="relative z-10 px-6 py-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="badge mb-4">💰 TRANSPARENT PRICING</div>
          <h2 className="text-5xl md:text-6xl font-bold mb-4 dark:text-white">Pick Your Power Level! ⚡</h2>
          <p className="text-xl text-gray-600 dark:text-gray-300">
            No hidden fees, no surprises – just awesome results
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {PRICING_PLANS.map((plan, index) => (
            <div
              key={plan.id}
              className="pricing-bubble relative bg-white rounded-3xl p-8 md:p-10 border-4 border-transparent hover:border-teal-700 transition-all hover:shadow-2xl hover:shadow-teal-700/30 text-gray-900"
              style={{ animationDelay: `${index * 0.5}s` }}
            >
              {/* Popular Badge */}
              {plan.popular && (
                <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-teal-700 to-cyan-500 text-white px-6 py-2 rounded-full text-sm font-bold shadow-lg">
                  {plan.badge}
                </div>
              )}

              {/* Non-popular Badge */}
              {!plan.popular && (
                <div className="text-sm font-bold text-gray-600 mb-2">{plan.badge}</div>
              )}

              {/* Emoji & Title */}
              <div className="text-6xl mb-4">{plan.emoji}</div>
              <div className="text-3xl font-bold mb-1 text-gray-900">{plan.name}</div>
              <div className="text-sm font-semibold text-gray-700 mb-6">{plan.tier}</div>

              {/* Price */}
              <div className="mb-6">
                {plan.price ? (
                  <>
                    <span className="text-4xl md:text-5xl font-bold gradient-text">
                      ${plan.price}
                    </span>
                    <span className="text-gray-600 text-lg">{plan.period}</span>
                  </>
                ) : (
                  <span className="text-4xl md:text-5xl font-bold gradient-text">
                    {plan.priceLabel}
                  </span>
                )}
              </div>

              {/* Features */}
              <ul className="space-y-3 mb-8">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-2">
                    <span className="text-xl md:text-2xl flex-shrink-0">✓</span>
                    <span className="text-gray-700 text-sm md:text-base">{feature}</span>
                  </li>
                ))}
              </ul>

              {/* CTA Button */}
              <Button
                variant="gradient"
                size="medium"
                fullWidth
                onClick={scrollToContact}
                className={`bg-gradient-to-r ${plan.gradient}`}
              >
                Get Started 🎉
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
